import { render, staticRenderFns } from "./realOrderList.vue?vue&type=template&id=2cc87d66&scoped=true&"
import script from "./realOrderList.vue?vue&type=script&lang=js&"
export * from "./realOrderList.vue?vue&type=script&lang=js&"
import style0 from "./realOrderList.vue?vue&type=style&index=0&id=2cc87d66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc87d66",
  null
  
)

export default component.exports